<template>
    <div class="library-satalia-filters" data-testid="library-satalia-filters">
        <CollapsibleWidget>
            <template #name>Pre-flight</template>

            <RadioGroup v-model="creativeLibraryFiltersStore.sataliaStatus" vertical>
                <Radio
                    v-for="sataliaOption in sataliaOptions"
                    :key="sataliaOption.value"
                    :label="sataliaOption.value"
                    class="satalia-options"
                >
                    {{ sataliaOption.label }}
                </Radio>
            </RadioGroup>
        </CollapsibleWidget>
    </div>
</template>

<script lang="ts" setup>
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";

import { PreflightStatusFilters } from "@/enums/filters";
import { useCreativeLibraryFiltersStore } from "@/store/pinia/creativeLibraryFilters";

const SataliaStatusFiltersLabels = {
    [PreflightStatusFilters.All]: "All",
    [PreflightStatusFilters.NotSent]: "Not Sent",
    [PreflightStatusFilters.Error]: "Error",
    [PreflightStatusFilters.Processing]: "Processing",
    [PreflightStatusFilters.Completed]: "Completed"
};

const sataliaOptions = Object.values(PreflightStatusFilters).map(value => ({
    label: SataliaStatusFiltersLabels[value],
    value
}));

const creativeLibraryFiltersStore = useCreativeLibraryFiltersStore();
</script>

<style lang="scss" scoped>
.library-satalia-filters {
    .ivu-radio-group {
        display: block;
    }

    .ivu-radio-wrapper {
        height: max-content;
        line-height: normal;
    }

    .satalia-options {
        padding-left: 50px;
    }
}
</style>
